
export const INITIAL_PROPERTY_RETURNS = [
    {
        id: 'unleveredIrr',
        name: 'Unlevered IRR',
        sheet: '',
        cell: '',
    },
    {
        id: 'leveredIrr',
        name: 'Levered IRR',
        sheet: '',
        cell: '',
    },
];

export const INITIAL_PARTNERSHIP_RETURNS = [
    {
        id: 'limitedPartnerIrr',
        name: 'Limited partner IRR',
        sheet: '',
        cell: '',
    },
    {
        id: 'generalPartnerIrr',
        name: 'General partner IRR',
        sheet: '',
        cell: '',
    },
];

export const INITIAL_DEVELOPMENT_RETURNS = [
    {
        id: 'untrendedYieldOnCost',
        name: 'Untrended yield-on-cost',
        sheet: '',
        cell: '',
    },
    {
        id: 'trendedYieldOnCost',
        name: 'Trended yield-on-cost',
        sheet: '',
        cell: '',
    },
];

export const INITIAL_OPERATIONS = [
    {
        id: 'effectiveGrossRevenue',
        name: 'Effective gross revenue',
        sheet: '',
        cell: '',
    },
    {
        id: 'totalOperatingExpenses',
        name: 'Total operating expenses',
        sheet: '',
        cell: '',
    },
    {
        id: 'netOperatingIncome',
        name: 'Net operating income',
        sheet: '',
        cell: '',
    },
    {
        id: 'capitalExpenditures',
        name: 'Capital expenditures',
        sheet: '',
        cell: '',
    },
    {
        id: 'cashFlowFromOps',
        name: 'Cash flow from operations',
        sheet: '',
        cell: '',
    },
];

export const INITIAL_VALUATION = [{
    id: 'valuation',
    name: 'Valuation',
    sheet: '',
    cell: '',
}];

export const INITIAL_DEVELOPMENT_USES = [
    {
        id: 'acquisitionCosts',
        name: 'Acquisition costs',
        sheet: '',
        cell: '',
    },
    {
        id: 'hardCosts',
        name: 'Hard costs',
        sheet: '',
        cell: '',
    },
    {
        id: 'softCosts',
        name: 'Soft costs',
        sheet: '',
        cell: '',
    },
    {
        id: 'financingCosts',
        name: 'Financing costs',
        sheet: '',
        cell: '',
    },
    {
        id: 'totalUses',
        name: 'Total uses',
        sheet: '',
        cell: '',
    },
];

export const INITIAL_DEVELOPMENT_SOURCES = [
    {
        id: 'constructionLoan',
        name: 'Construction loan',
        sheet: '',
        cell: '',
        isSource: true,
    },
    {
        id: 'mezzanineLoan',
        name: 'Mezzanine loan',
        sheet: '',
        cell: '',
        isSource: true,
    },
    {
        id: 'limitedPartner',
        name: 'Limited partner',
        sheet: '',
        cell: '',
        isSource: true,
    },
    {
        id: 'generalPartner',
        name: 'General partner',
        sheet: '',
        cell: '',
        isSource: true,
    },
    {
        id: 'totalSources',
        name: 'Total sources',
        sheet: '',
        cell: '',
        isSource: true,
    },
];

export const getUniqueName = (baseName: string, existingNames: string[]) => {
    let newName = baseName;
    let counter = 1;

    while (existingNames.includes(newName)) {
        newName = `${baseName}_${counter}`;
        counter++;
    }

    return newName;
};

export const createNewDevelopmentSourceRow = (existingRows: any[] = []) => {
    const baseName = 'New source';
    const existingNames = existingRows.map(row => row.name);
    const newName = getUniqueName(baseName, existingNames);

    return {
        id: `source_${Date.now()}`,
        name: newName,
        sheet: '',
        cell: '',
        isSource: true,
    };
};

export const INITIAL_ACQUISITIONS = [{
    id: 'acquisitionCosts',
    name: 'Acquisition costs',
    sheet: '',
    cell: '',
}];

export enum ProFormaMappingTableNames {
  PROPERTY_RETURNS = 'propertyReturns',
  PARTNERSHIP_RETURNS = 'partnershipReturns',
  DEVELOPMENT_RETURNS = 'developmentReturns',
  OPERATIONS = 'operations',
  VALUATION = 'valuation',
  DEVELOPMENT_USES = 'developmentUses',
  DEVELOPMENT_SOURCES = 'developmentSources',
  ACQUISITIONS = 'acquisitions'
}

export enum ProFormaMappingRowNames {
  UNLEVERED_IRR = 'Unlevered IRR',
  LEVERED_IRR = 'Levered IRR',
  LIMITED_PARTNER_IRR = 'Limited partner IRR',
  GENERAL_PARTNER_IRR = 'General partner IRR',
  UNTRENDED_YIELD_ON_COST = 'Untrended yield-on-cost',
  TRENDED_YIELD_ON_COST = 'Trended yield-on-cost',
  EFFECTIVE_GROSS_REVENUE = 'Effective gross revenue',
  TOTAL_OPERATING_EXPENSES = 'Total operating expenses',
  NET_OPERATING_INCOME = 'Net operating income',
  CAPITAL_EXPENDITURES = 'Capital expenditures',
  CASH_FLOW_FROM_OPS = 'Cash flow from operations',
  VALUATION = 'Valuation',
  ACQUISITION_COSTS = 'Acquisition costs',
  HARD_COSTS = 'Hard costs',
  SOFT_COSTS = 'Soft costs',
  FINANCING_COSTS = 'Financing costs',
  TOTAL_USES = 'Total uses',
  TOTAL_SOURCES = 'Total sources'
}

export const BASE_TABLE_NAME_TO_ROW_NAME = {
    [ProFormaMappingRowNames.UNLEVERED_IRR]: ProFormaMappingTableNames.PROPERTY_RETURNS,
    [ProFormaMappingRowNames.LEVERED_IRR]: ProFormaMappingTableNames.PROPERTY_RETURNS,
    [ProFormaMappingRowNames.LIMITED_PARTNER_IRR]: ProFormaMappingTableNames.PARTNERSHIP_RETURNS,
    [ProFormaMappingRowNames.GENERAL_PARTNER_IRR]: ProFormaMappingTableNames.PARTNERSHIP_RETURNS,
    [ProFormaMappingRowNames.UNTRENDED_YIELD_ON_COST]: ProFormaMappingTableNames.DEVELOPMENT_RETURNS,
    [ProFormaMappingRowNames.TRENDED_YIELD_ON_COST]: ProFormaMappingTableNames.DEVELOPMENT_RETURNS,
    [ProFormaMappingRowNames.EFFECTIVE_GROSS_REVENUE]: ProFormaMappingTableNames.OPERATIONS,
    [ProFormaMappingRowNames.TOTAL_OPERATING_EXPENSES]: ProFormaMappingTableNames.OPERATIONS,
    [ProFormaMappingRowNames.NET_OPERATING_INCOME]: ProFormaMappingTableNames.OPERATIONS,
    [ProFormaMappingRowNames.CAPITAL_EXPENDITURES]: ProFormaMappingTableNames.OPERATIONS,
    [ProFormaMappingRowNames.CASH_FLOW_FROM_OPS]: ProFormaMappingTableNames.OPERATIONS,
    [ProFormaMappingRowNames.VALUATION]: ProFormaMappingTableNames.VALUATION,
};

export const DEVELOPMENT_DEAL_TABLE_NAME_TO_ROW_KEY_NAME: Record<string, ProFormaMappingTableNames> = {
    ...BASE_TABLE_NAME_TO_ROW_NAME,
    [ProFormaMappingRowNames.ACQUISITION_COSTS]: ProFormaMappingTableNames.DEVELOPMENT_USES,
    [ProFormaMappingRowNames.HARD_COSTS]: ProFormaMappingTableNames.DEVELOPMENT_USES,
    [ProFormaMappingRowNames.SOFT_COSTS]: ProFormaMappingTableNames.DEVELOPMENT_USES,
    [ProFormaMappingRowNames.FINANCING_COSTS]: ProFormaMappingTableNames.DEVELOPMENT_USES,
    [ProFormaMappingRowNames.TOTAL_USES]: ProFormaMappingTableNames.DEVELOPMENT_USES,
    [ProFormaMappingRowNames.TOTAL_SOURCES]: ProFormaMappingTableNames.DEVELOPMENT_SOURCES,
};

export const ACQUISITIONS_DEAL_TABLE_NAME_TO_ROW_KEY_NAME = {
    ...BASE_TABLE_NAME_TO_ROW_NAME,
    [ProFormaMappingRowNames.ACQUISITION_COSTS]: ProFormaMappingTableNames.ACQUISITIONS,
};

export const HIGHLIGHTED_ROW_NAMES = [
    ProFormaMappingRowNames.NET_OPERATING_INCOME,
    ProFormaMappingRowNames.CASH_FLOW_FROM_OPS,
    ProFormaMappingRowNames.VALUATION,
    ProFormaMappingRowNames.TOTAL_USES,
    ProFormaMappingRowNames.TOTAL_SOURCES,
];

export enum ProFormaMappingTableHeaderNames {
  PROPERTY_RETURNS = 'Property returns',
  PARTNERSHIP_RETURNS = 'Partnership returns',
  DEVELOPMENT_RETURNS = 'Development returns',
  OPERATIONS = 'Operation',
  VALUATION = 'Valuation',
  DEVELOPMENT_USES = 'Uses',
  DEVELOPMENT_SOURCES = 'Sources',
  ACQUISITIONS = 'Acquisition'
}

export enum ProFormaMappingSectionNames {
  RETURNS = 'Returns',
  OPERATIONS = 'Operations',
  DEVELOPMENT = 'Development',
  ACQUISITIONS = 'Acquisition'
}

export const BASE_PRO_FORMA_MAPPING: Partial<Record<ProFormaMappingTableNames, any>> = {
    [ProFormaMappingTableNames.PROPERTY_RETURNS]: INITIAL_PROPERTY_RETURNS,
    [ProFormaMappingTableNames.PARTNERSHIP_RETURNS]: INITIAL_PARTNERSHIP_RETURNS,
    [ProFormaMappingTableNames.DEVELOPMENT_RETURNS]: INITIAL_DEVELOPMENT_RETURNS,
    [ProFormaMappingTableNames.OPERATIONS]: INITIAL_OPERATIONS,
    [ProFormaMappingTableNames.VALUATION]: INITIAL_VALUATION,
};

export const DEVELOPMENT_DEAL_PRO_FORMA_MAPPING: Partial<Record<ProFormaMappingTableNames, any>> = {
    ...BASE_PRO_FORMA_MAPPING,
    [ProFormaMappingTableNames.DEVELOPMENT_USES]: INITIAL_DEVELOPMENT_USES,
    [ProFormaMappingTableNames.DEVELOPMENT_SOURCES]: INITIAL_DEVELOPMENT_SOURCES,
};

export const ACQUISITION_DEAL_PRO_FORMA_MAPPING: Partial<Record<ProFormaMappingTableNames, any>> = {
    ...BASE_PRO_FORMA_MAPPING,
    [ProFormaMappingTableNames.ACQUISITIONS]: INITIAL_ACQUISITIONS,
};

export const ACCEPTED_PRO_FORMA_FILE_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'application/vnd.ms-excel', // .xls and .xlsm on some Windows browsers
    'application/vnd.ms-excel.sheet.macroenabled.12', // .xlsm
    'application/octet-stream', // .xlsm fallback on some Windows browsers
];

export const EXCEL_LAST_COLUMN_XFD = 16384; // XFD is the last column in Excel
export const EXCEL_LAST_ROW = 1048576;

export const PREVIEW_MIN_HEIGHT = 800;

export const PREVIEW_RETURNS_FIELDS = {
    UNLEVERED_IRR: ProFormaMappingRowNames.UNLEVERED_IRR.toUpperCase(),
    GENERAL_PARTNER_IRR: ProFormaMappingRowNames.GENERAL_PARTNER_IRR.toUpperCase(),
    UNTRENDED_YIELD_ON_COST: ProFormaMappingRowNames.UNTRENDED_YIELD_ON_COST.toUpperCase(),
    LEVERED_IRR: ProFormaMappingRowNames.LEVERED_IRR.toUpperCase(),
    LIMITED_PARTNER_IRR: ProFormaMappingRowNames.LIMITED_PARTNER_IRR.toUpperCase(),
    TRENDED_YIELD_ON_COST: ProFormaMappingRowNames.TRENDED_YIELD_ON_COST.toUpperCase(),
};

export const IS_BUDGET_EXTRACTION_ENABLED = false;
